import {
  GET_INBOX_SETUP,
  GET_INBOX_SETUP_FAILED,
  GET_INBOX_SETUP_SUCCESS,
  GET_LIST_SCREEN_SETUP,
  GET_LIST_SCREEN_SETUP_FAILED,
  GET_LIST_SCREEN_SETUP_SUCCESS,
  UPDATE_INBOX_SETUP,
  UPDATE_INBOX_SETUP_FAILED,
  UPDATE_INBOX_SETUP_SUCCESS,
  UPDATE_LIST_SCREEN_SETUP,
  UPDATE_LIST_SCREEN_SETUP_FAILED,
  UPDATE_LIST_SCREEN_SETUP_SUCCESS,
} from "./actionTypes"

export const getListScreenSetup = params => ({
  type: GET_LIST_SCREEN_SETUP,
  payload: params,
})

export const getListScreenSetupSuccess = response => ({
  type: GET_LIST_SCREEN_SETUP_SUCCESS,
  payload: response,
})

export const getListScreenSetupFailed = error => ({
  type: GET_LIST_SCREEN_SETUP_FAILED,
  payload: error,
})

export const getInboxSetup = params => ({
  type: GET_INBOX_SETUP,
  payload: params,
})

export const getInboxSetupSuccess = response => ({
  type: GET_INBOX_SETUP_SUCCESS,
  payload: response,
})

export const getInboxSetupFailed = error => ({
  type: GET_INBOX_SETUP_FAILED,
  payload: error,
})

export const updateInboxSetup = params => ({
  type: UPDATE_INBOX_SETUP,
  payload: params,
})

export const updateInboxSetupSuccess = response => ({
  type: UPDATE_INBOX_SETUP_SUCCESS,
  payload: response,
})

export const updateInboxSetupFailed = error => ({
  type: UPDATE_INBOX_SETUP_FAILED,
  payload: error,
})

export const updateListScreenSetup = params => ({
  type: UPDATE_LIST_SCREEN_SETUP,
  payload: params,
})

export const updateListScreenSetupSuccess = response => ({
  type: UPDATE_LIST_SCREEN_SETUP_SUCCESS,
  payload: response,
})

export const updateListScreenSetupFailed = error => ({
  type: UPDATE_LIST_SCREEN_SETUP_FAILED,
  payload: error,
})
